import React, { useEffect, useState } from 'react';
import { FaGoogle, FaStar } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import opinionBanner from '../../images/team/MedicalLaboratoryBanner.png';
import API_ENDPOINTS from '../../api';

const Opinion = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  const [opinions, setOpinions] = useState([]);
  
  useEffect(() => {
    fetch(API_ENDPOINTS.OPINIONS.GET_ALL)
      .then(res => res.json())
      .then(data => {
        if (data.status === 'success') {
          setOpinions(data.opinion);
          console.log("data",data);
          
        }
      });
  }, []);

  console.log("opinion" , opinions);
  
  
  const fixedOpinion = [
    {
      text: 'بصراحة المركز والاستاف الموجودين فيه منتهى الذوق والاحترام والمعاملة الجميلة، تعاملت مع الدكتورة مروة والأستاذة ميادة، ناس في قمة الذوق.',
      timeAgo: 'منذ أسبوعين',
      rating: 5,
      isNew: true,
    },
    {
      text: 'The service was excellent and professional. Thank you very much.',
      timeAgo: 'A month ago',
      rating: 5,
    },
    {
      text: 'Very nice work. Many thanks especially for Dr. Amira.',
      timeAgo: 'A month ago',
      rating: 5,
    },
    {
      text: 'ما شاء الله المختبر رائع وخدمات مميزة وتعامل راقي جداً.',
      timeAgo: 'منذ 5 أيام',
      rating: 5,
      isNew: true,
    },
    {
      text: 'مكان نظيف جداً والموظفين محترفين. النتائج سريعة ودقيقة.',
      timeAgo: 'منذ 3 أسابيع',
      rating: 5,
    },
    {
      text: 'Best medical lab in Khorfakkan. Highly recommended!',
      timeAgo: '1 week ago',
      rating: 5,
      isNew: true,
    },
  ];



  const handleGoogleReviewClick = () => {
    window.open('https://share.google/IilNA8mAPXNOGZTtZ', '_blank');
  };

  const renderStars = (rating) =>
    Array.from({ length: 5 }, (_, i) => (
      <FaStar
        key={i}
        className={i < rating ? 'text-yellow-400' : 'text-gray-300'}
      />
    ));

  return (
    <section dir={isRTL ? 'rtl' : 'ltr'} className="bg-white">
      {/* ================= Header ================= */}
      <header
        className="relative h-[200px] md:h-[200px] flex items-center justify-center text-white overflow-hidden"
        style={{
          backgroundImage: `url(${opinionBanner})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-black/80 via-black/60 to-black/90"></div>

        {/* Google Review Button (Top) */}
        <div
          className={`absolute top-6 ${
            isRTL ? 'left-6' : 'right-6'
          } z-20`}
        >
          <button
            onClick={handleGoogleReviewClick}
            className="flex items-center gap-3 px-5 py-3 bg-white/95 backdrop-blur-md text-gray-900 rounded-full shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300"
          >
            <FaGoogle className="text-red-500 text-xl" />
            <div className="text-sm leading-tight">
              <span className="block font-semibold text-secondColor">
                {t('opinion.googleReviewButton')}
              </span>
              <span className="block text-xs text-gray-500">
                {t('opinion.google')}
              </span>
            </div>
          </button>
        </div>

        {/* Header Content */}
        <div className="relative z-10 text-center px-6">
            <h1 className="text-4xl md:text-5xl font-extrabold mb-4">
              {t('opinion.title')}
            </h1>
            <span className="block w-28 h-1 bg-secondColor mx-auto mb-4 rounded-full"></span>
            <p className="text-lg md:text-xl text-gray-200 max-w-xl mx-auto">
              {t('opinion.subheading')}
            </p>
        </div>
      </header>

      {/* ================= Reviews ================= */}
      <div className="container mx-auto px-6 max-w-6xl py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {opinions.map((review, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-3xl p-6 shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
            >
              <div className="flex items-center justify-between mb-4">
                <div className="flex gap-1">
                  {renderStars(review.rating)}
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-500">
                  <span>{review.timeAgo}</span>
                  {review.isNew && (
                    <span className="bg-green-100 text-green-700 text-xs px-3 py-1 rounded-full font-semibold">
                      {t('opinion.new')}
                    </span>
                  )}
                </div>
              </div>

              <p className="text-gray-800 leading-relaxed whitespace-pre-line">
                {review.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Opinion;
